import {WIDGET_KEYS} from "../constants/WidgetKeys.jsx";
import {ALERT_TYPES} from "../constants/OtherKeys.jsx";

export const GRID_COMBO_EDITOR_DEFAULTS = {
  type: WIDGET_KEYS.settingsCombo,
  clearable: true,
  hidePickerOnSelect: true,
  // We want picker list width to not go beyond our min width
  picker: {
    listeners: {
      paint({ source }) {
        if (source.owner.width < 150) source.minWidth = 150;
      }
    },
  }
}

export const GRID_DEFAULT_TEXT = "No data yet.";

export const SWIVU_TASK_DEFAULT_COLOR = "#2196F3";
export const swivuAlertBellActiveCls = "bell-active";
export const swivuAlertBellWarnCls = "bell-warn";

export const SWIVU_NOTIFY_COLOR_ID = {
  [ALERT_TYPES.REMINDER]: "notification-reminder",
  [ALERT_TYPES.Nudge]: "notification-nudge",
  [ALERT_TYPES.Schedule]: "notification-schedule",
  [ALERT_TYPES.Checklist]: "notification-checklist",
  [ALERT_TYPES.EntityStatus]: "notification-status",
  [ALERT_TYPES.NOTE]: "notification-note",
  [ALERT_TYPES.Weather]: "notification-weather",
  [ALERT_TYPES.GENERAL]: "notification-general",
  [ALERT_TYPES.URGENT]: "notification-urgent",
}